import React, { useCallback } from 'react';
import { observer } from 'mobx-react';

import { RequestQuoteForm } from '@canvas-logic/clp-shared-ui';

import { ContactUsService } from '@/ui-kit/services/ContactUsService';
import { RequestQuoteFormStatus } from '@/ui-kit/components/RequestQuote/RequestQuoteFormStatus';

import styles from './RequestQuote.module.css';

interface RequestQuoteProps {
  contactUsService: ContactUsService;
  createLink?: () => Promise<string>;
}

export const RequestQuote = observer(function RequestQuote({ contactUsService, createLink }: RequestQuoteProps) {
  const { requestStatus } = contactUsService;

  const onSubmit = useCallback(
    async (formData: Record<string, string>) => {
      let data = formData;

      if (createLink) {
        const link = await createLink();
        data = { ...formData, configurationLink: link };
      }

      await contactUsService.requestQuote(data);
    },
    [contactUsService, createLink],
  );

  return (
    <div className={styles.container}>
      {requestStatus !== 'idle' ? (
        <RequestQuoteFormStatus status={requestStatus} />
      ) : (
        <RequestQuoteForm schema={contactUsService.schema} onSubmit={onSubmit} />
      )}
    </div>
  );
});
